import { getEventDetail } from "api/layer";
import processTcTrackArray from "./data/calc";
import { TcTrackPoint } from "./data/type";
import { clearLine, connectPointsWithColoredLines, hideAllLine, showAllLine } from "./marker/line";
import { addCircleMarkersToMap, clearPoint, hideAllPoints, showAllPoints } from "./marker/point";
import getValidFeatures from "./data/feature";

const cache: Record<string, any> = {};

export async function addTcTrack(eventId: string, map: any, t: any, isShowTcTrack: boolean) {
  if (!cache[eventId]) {
    const res = await getEventDetail(eventId);
    cache[eventId] = res;
  }

  const features = getValidFeatures(eventId, cache[eventId]);
  if (!features) return;

  const updateDateTime = cache[eventId]?.data?.updateDateTime
  const pointArray: TcTrackPoint[] = processTcTrackArray(eventId, features, updateDateTime);
  addCircleMarkersToMap(eventId, map, pointArray, t, isShowTcTrack);
  connectPointsWithColoredLines(eventId, map, pointArray, isShowTcTrack);
}

export function clearTcTrack(eventId: string, map: any) {
  if (!eventId || !map) {
    return;
  }

  clearPoint(eventId, map);
  clearLine(eventId, map);
}

export function showTcTrack() {
  showAllPoints();
  showAllLine();
}

export function hideTcTrack() {
  hideAllPoints();
  hideAllLine();
}